export enum Pipe {
  BookingDataHash = '-',
}
